import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

import { Button } from '@material-ui/core';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, domain } from '../../routes/routes'

/* Object Json */
import { safeDeepGetWithType } from 'iotera-base/json';

import { IoteraForm } from '../../lib/components/form';
import { SubViewHeader } from '../../lib/components/subHeader';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const WKEY = "ABOUT";
const wBoundActions = buildWBoundActions(WKEY);
const wSelector = buildWSelector(WKEY)

function schema() {
  return {
    type: "object",
    required: ["id", "name", "domain", "created_time"],
    properties: {
      id: { type: "string", title: "Application Id" },
      name: { type: "string", title: "Application Name" },
      domain: { type: "string", title: "Application Domain" },
      created_time: { type: "string", title: "Created Time" }
    }
  }
};

const uiSchema = {
  id: {
    "ui:disabled": true
  },
  name: {
    "ui:disabled": true
  },
  domain: {
    "ui:disabled": true
  },
  created_time: {
    "ui:disabled": true
  }
};

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall({
      wparam: {
        ...domainIsTenant,
        method: "GET",
        path: "/service/web/application/get/domain/" + domains
      },
      wcallback: {
        finished: function (id, result) {
          if (result.code === Result.HTTP.OK) {
            const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
            if (responseResult === Result.SUCCESS) {
              _this.setState({
                loading: false
              })
              return
            }
          }
          _this.setState({ loading: false })
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  render() {
    const _this = this;
    const _state = _this.state
    const _props = _this.props
    const { loading } = _state;
    const data = safeDeepGetWithType(_props, ['app'], {})
    let dataToShow = data;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='About' subTitle='Formulir tentang aplikasi' />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema()}
              uiSchema={uiSchema}
              formData={dataToShow}
            >
              <div className="button-right">
                <Button variant="outlined" type="button" size="large"
                  style={{ minWidth: '0%' }} disabled hidden >Batal</Button>
                <Button variant="contained" type="submit" size="large" color="primary"
                  style={{ marginLeft: 10, minWidth: '0%' }} disabled hidden>Simpan</Button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    app: wSelector.getSoleInitMappedRPayload(state)
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(About));